import { Routes } from '@angular/router';
import { authGuard } from '@umss/shared/core';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('@umss/contractor/feature-auth').then((m) => m.routes)
  },
  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () =>
      import('@umss/contractor/feature-shell').then((m) => m.shellRoutes)
  },
  // fallback
  { path: '**', redirectTo: 'dashboard' }
];
